module.exports = "<div class=\"container-fluid\">\n<app-navbar></app-navbar>\n<router-outlet></router-outlet>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// /apps/dev/flashqubes/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = 2